var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-14_12_",
    d: "M7.15385 3.5564C9.76923 3.5564 11.9231 5.71021 11.9231 8.32559C11.9231 9.17174 11.6923 10.0179 11.2308 10.7871L11 11.2487L11.4615 12.7102C11.6154 13.2486 12 13.6333 12.5385 13.941C13 14.1718 13.3077 14.6334 13.3077 15.1719V15.4795C13.3077 16.0949 12.7692 16.6333 12.1538 16.6333H2.15385C1.53846 16.6333 1 16.0949 1 15.4795V15.1719C1 14.6334 1.30769 14.1718 1.76923 13.941C2.23077 13.7102 2.61539 13.2486 2.84616 12.7102L3.30769 11.2487L3.07692 10.7871C1.69231 8.55632 2.46154 5.55632 4.69231 4.24863C5.46154 3.78709 6.30769 3.5564 7.15385 3.5564Z",
    stroke: "var(--secondary-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-13_6_",
    d: "M7.1537 21.2488C8.00337 21.2488 8.69216 20.56 8.69216 19.7103C8.69216 18.8607 8.00337 18.1719 7.1537 18.1719C6.30403 18.1719 5.61523 18.8607 5.61523 19.7103C5.61523 20.56 6.30403 21.2488 7.1537 21.2488Z",
    stroke: "var(--secondary-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-57_12_",
    d: "M5.61523 3.5572V2.78797C5.61523 1.94182 6.30754 1.24951 7.1537 1.24951C7.99985 1.24951 8.69216 1.94182 8.69216 2.78797V3.5572",
    stroke: "var(--secondary-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f03ff32ec2e56a66123f74ddfbbcc679.svg";
export { ForwardRef as ReactComponent };